// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"73221dcb","990":"4231f4e8"}[chunkId] + ".chunk.js";
};